import { useRef, useState } from 'react';
import { useDrop } from 'react-dnd';

interface TaskDropZoneProps {
  children: React.ReactNode;
  onTaskDrop: (taskId: string, newPriority: number) => void;
  className?: string;
}

export default function TaskDropZone({
  children,
  onTaskDrop,
  className = '',
}: TaskDropZoneProps) {
  const [isOver, setIsOver] = useState(false);
  const dropRef = useRef<HTMLDivElement>(null);

  const [{ isOver: isOverDrop }, drop] = useDrop(
    () => ({
      accept: 'task',
      drop: (item: any, monitor) => {
        if (monitor.didDrop()) return;

        // Calculate new priority based on drop position
        const clientOffset = monitor.getClientOffset();
        if (!clientOffset || !dropRef.current) return;

        const dropRect = dropRef.current.getBoundingClientRect();
        const relativeY = clientOffset.y - dropRect.top;

        // Find the task element at the drop position
        const taskElements = dropRef.current.querySelectorAll('[data-task-id]');
        let newPriority = 0;

        for (let i = 0; i < taskElements.length; i++) {
          const taskElement = taskElements[i] as HTMLElement;
          const taskRect = taskElement.getBoundingClientRect();

          if (relativeY < taskRect.top - dropRect.top + taskRect.height / 2) {
            // Insert before this task
            newPriority = i;
            break;
          }
          newPriority = i + 1;
        }

        // Call the onTaskDrop function directly
        console.log(
          'TaskDropZone: Dropping task',
          item.id,
          'with priority',
          newPriority
        );
        onTaskDrop(item.id, newPriority);

        // Return the priority in the drop result for the drag end callback
        return { priority: newPriority };
      },
      hover: (item, monitor) => {
        setIsOver(true);
      },
      collect: monitor => ({
        isOver: monitor.isOver(),
      }),
    }),
    [onTaskDrop]
  );

  return (
    <div
      ref={node => {
        dropRef.current = node;
        drop(node);
      }}
      className={`transition-all duration-300 ease-in-out ${
        isOverDrop ? 'drop-zone-active p-2' : ''
      } ${className}`}
      onMouseLeave={() => setIsOver(false)}
    >
      {children}
    </div>
  );
}
